import { render } from "./shop-sidebar-area.vue?vue&type=template&id=28679bca"
import script from "./shop-sidebar-area.vue?vue&type=script&lang=js"
export * from "./shop-sidebar-area.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__